export class Poll {
    $key: string;
    title: string;
    answersCount: number = 0;
    eventId: string;
    type: string;
    from: string;
    isMultipleAnswersAllowed: boolean = false;
    isReasonAvailable: boolean = false;
    isReasonMandatory: boolean = false;
    pollQuestion: string;
    sessionId: string;
    options = new Array<string>();
    counters = new Array<number>(null);
    totalAnswer: number = 0;
    position: number;
}


// WEBPACK FOOTER //
// /app/src/app/core/models/poll.ts